import { render, staticRenderFns } from "./ContinueShopping.vue?vue&type=template&id=487b15e0&scoped=true&"
import script from "./ContinueShopping.vue?vue&type=script&lang=ts&"
export * from "./ContinueShopping.vue?vue&type=script&lang=ts&"
import style0 from "./ContinueShopping.vue?vue&type=style&index=0&id=487b15e0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487b15e0",
  null
  
)

export default component.exports